import { render, staticRenderFns } from "./NpaCategories.vue?vue&type=template&id=03d55c65"
import script from "./NpaCategories.vue?vue&type=script&lang=js"
export * from "./NpaCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports